import React from "react";
import NewFeedSingleImage from "./NewFeedSignleImage";

const NewFeedPostImages: React.FC<{
  images: string[];
  post: any;
  onOpenPostModal: (postId: string) => void;
}> = ({ images, post, onOpenPostModal }) => {
  const onGoToPost = (postId: string) => {
    onOpenPostModal(post.post_id);
  };

  return images.length === 1 ? (
    <NewFeedSingleImage post={post} onOpenPostModal={onOpenPostModal} />
  ) : (
    <div className="relative w-full aspect-square grid gap-1">
      {images.length === 2 && (
        <div className="grid grid-cols-2 gap-1 w-full h-full">
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt="post"
              className="w-full h-full object-cover aspect-square "
              onClick={() => onGoToPost(post.post_id)}
            />
          ))}
        </div>
      )}

      {images.length === 3 && (
        <div className="grid grid-cols-2 grid-rows-2 gap-1 w-full h-full">
          <div className="col-span-1 row-span-2 overflow-hidden flex">
            <img
              src={images[0]}
              alt="post"
              className="w-full h-full object-cover aspect-square "
              onClick={() => onGoToPost(post.post_id)}
            />
          </div>
          <div className="col-span-1 row-span-1 overflow-hidden flex">
            <img
              src={images[1]}
              alt="post"
              className="w-full h-full object-cover aspect-square "
              onClick={() => onGoToPost(post.post_id)}
            />
          </div>
          <div className="col-span-1 row-span-1 overflow-hidden flex">
            <img
              src={images[2]}
              alt="post"
              className="w-full h-full object-cover aspect-square "
              onClick={() => onGoToPost(post.post_id)}
            />
          </div>
        </div>
      )}

      {images.length === 4 && (
        <div className="grid grid-cols-2 grid-rows-2 gap-1 w-full h-full">
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt="post"
              className="w-full h-full object-cover aspect-square "
              onClick={() => onGoToPost(post.post_id)}
            />
          ))}
        </div>
      )}

      {images.length > 4 && (
        <div className="grid grid-cols-2 grid-rows-2 gap-1 w-full h-full relative">
          {images.slice(0, 3).map((image, index) => (
            <img
              key={index}
              src={image}
              alt="post"
              className="w-full h-full object-cover aspect-square "
              onClick={() => onGoToPost(post.post_id)}
            />
          ))}
          <div className="relative w-full h-full overflow-hidden flex">
            <img
              src={images[3]}
              alt="post"
              className="w-full h-full object-cover aspect-square "
              onClick={() => onGoToPost(post.post_id)}
            />
            <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center text-white font-bold text-xl ">
              +{images.length - 4}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewFeedPostImages;

